import React from 'react';
import styles from './style.scss';

const title = '404';
const primaryMessagePrefix = 'Oh no!';
const primaryMessage = 'We couldn\'t find your order.';
const firstSecondaryMessage = 'Check your order details and try again.';
const secondSecondaryMessage = 'If you\'re still having trouble, please contact your retailer for more information.';

function NotFoundPage() {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.title}>{title}</div>
        <div className={styles.primaryText}>
          <span className={styles.prefix}>{primaryMessagePrefix}</span>
          <span className={styles.mainContent}>{` ${primaryMessage}`}</span>
        </div>
        <hr className={styles.separator} />
        <div className={styles.secondaryText}>
          <div>{firstSecondaryMessage}</div>
          <div>{secondSecondaryMessage}</div>
        </div>
        <hr className={styles.separator} />
      </div>
    </div>
  );
}

export default NotFoundPage;
